/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LocationDetailsBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return LocationDetailsBase.fixupPrototype; }

    static newInstance(model: Partial<LocationDetailsBase>): LocationDetailsBase {
        let obj = Object.assign(new LocationDetailsBase(), model);
        LocationDetailsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LocationDetailsBase>): LocationDetailsBase {
        if (!model) return null;
        return LocationDetailsBase.newInstance(<LocationDetailsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LocationDetailsBase) {
        if (!obj) return;

        models.LocationDetailsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LocationDetailsBase): boolean {
        switch (obj.type)
        {
            case "LocationDetailsForAws":
                Object.setPrototypeOf(obj, models.LocationDetailsForAws.prototype);
                break;
            case "LocationDetailsForAzure":
                Object.setPrototypeOf(obj, models.LocationDetailsForAzure.prototype);
                break;
            case "LocationDetailsForGcp":
                Object.setPrototypeOf(obj, models.LocationDetailsForGcp.prototype);
                break;
            case "LocationDetailsForOci":
                Object.setPrototypeOf(obj, models.LocationDetailsForOci.prototype);
                break;
            case "LocationDetailsForOpenstack":
                Object.setPrototypeOf(obj, models.LocationDetailsForOpenstack.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof LocationDetailsBase)[] {
        return [
            models.LocationDetailsForAws,
            models.LocationDetailsForAzure,
            models.LocationDetailsForGcp,
            models.LocationDetailsForOci,
            models.LocationDetailsForOpenstack,
        ];
    }

    fixupFields() {
    }

    /**
     * Unique Id
     */
    location_id: string;

    /**
     * Display Name
     */
    name: string;

    /**
     * Description
     */
    description: string;

}
